export default __webpack_public_path__ + "4cdf79e5f25e030a87d52a2ad948fddd.png";